const t='.gator-alert-title{color:var(--color-text-primary-base, #1F1F1F);font-family:var(--text-family-body, "Open Sans", sans-serif);font-size:1.5rem;font-weight:700}';export{t as default};
